import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface AuthUser {
	id: string
	email: string
	phone: string
	name: string
}

interface AuthState {
	token: string | null
	user: AuthUser | null
}

// NOTE: The auth slice is persisted to localStorage via redux-persist (see store/index.ts).
// This is a known XSS trade-off. Plan: replace with httpOnly cookies when backend supports it.
const initialState: AuthState = {
	token: null,
	user: null,
}

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setCredentials(state, action: PayloadAction<{ token: string; user: AuthUser }>) {
			state.token = action.payload.token
			state.user = action.payload.user
		},
		logout(state) {
			state.token = null
			state.user = null
		},
	},
})

export const { setCredentials, logout } = authSlice.actions
export default authSlice.reducer
